<template>
  <div class="list">
    <p v-if="viewBookmark && list.length === 0" class="emptyBookmark">{{locale.tv_bookmark_empty_message}}</p>
    <ChannelItem v-for="item in list"
      :key="item.id"
      :lang="lang"
      :locale="locale"
      :item="item"
      :isControl="isControl"
      :tvIndex="tvIndex"
      @bookmark="bookmarkItem"
      @toast="toast" />
  </div>
</template>

<script>
import ChannelItem from '@/components/TvControl/ChannelItem.vue'

export default {
  name: 'ChannelList',
  props: [
    'lang',
    'locale',
    'list',
    'isControl',
    'viewBookmark',
    'tvIndex'
  ],
  components: {
    ChannelItem
  },
  methods: {
    bookmarkItem (id) {
      this.$emit('chBookmark', id)
    },
    toast (message) {
      this.$emit('toast', message)
    }
  }
}
</script>

<style lang="scss" scoped>
.emptyBookmark {
  flex: 1;
  text-align: center;
  padding: 60px 15px 120px;
  &:before {
    content: "\2605";
    display: block;
    margin-bottom: 10px;
    font-size: 72px;
    color: #ffb203;
    line-height: 1;
  }
}
</style>
